module.exports = __webpack_public_path__ + "img/topE.618a4386.jpg";